// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__2Gcf4","listItem":"style_listItem__1ACgz"};